/**
 * @author Vikrant.
 * @since 02-01-2024.
 * @type {string} KYC action types.
 */

export const SET_LOADING = '[KYC] SET_LOADING';
export const SET_USER_KYC_LIST = '[KYC] SET_USER_KYC_LIST';
export const SET_USER_KYC_LIST_META = '[KYC] SET_USER_KYC_LIST_META';
